<template>
    <div class="container">
        <el-page-header @back="goBack" content="待办事件" style="margin-bottom: 30px;" />
        <el-container class="body-container">
            <el-aside width="33%">
                <UserInfo :userId="userId"></UserInfo>
            </el-aside>
            <el-main>
                <pending-timeline
                    :pendingRemarkList="pendingRemarkList"
                    :show-edit="showEventEdit"
                    @change-show="handleEventShow"
                    @change-save="handleEventSave"/>
            </el-main>
            <el-aside width="33%">
                <UserHistoryRemark
                    :remarkHistoryList="remarkHistoryList"
                    :show-edit="showHistoryEdit"
                    @change-show="handleHistoryShow"
                    @change-save="handleHistorySave"/>
            </el-aside>
        </el-container>
    </div>
</template>
<script>
import request from "@/api/request";
import UserInfo from '@/modules/saas/UserInfo.vue'
import UserHistoryRemark from '@/modules/saas/UserHistoryRemark.vue'
import PendingTimeline from '@/modules/saas/PendingTimeline.vue'
export default {
    components: {
        UserInfo,
        UserHistoryRemark,
        PendingTimeline
    },
    data(){
        return{
            settlementRateTemplate: {},
            rate: {},
            taxRateTemplate: {},
            taxId: null,
            settlementId: null,
            detailItem: {},
            front_url: '',
            back_url: '',
            company_license_url: '',
            userId: this.$route.params.id,
            showEventEdit: false,
            pendingRemarkList: {},
            remarkHistoryList: {},
            showHistoryEdit: false
        }
    },
    mounted() {
        this.getUserDetailInfo()  
        this.getRemarkList()
    },
    methods: {
        getRemarkList(){
            request.saas
                .post('uc/get_user_remark_list', {
                    user_id: this.userId,
                    range: [0,100],
                    type: [2]
                })
                .then(res => {
                    console.log(res)
                    this.getRemarkHistoryList()
                    this.pendingRemarkList = res.data.list
                })
        },
        getRemarkHistoryList(){
            request.saas
                .post('uc/get_user_remark_list', {
                    user_id: this.userId,
                    range: [0,100],
                    type: [1,2]
                })
                .then(res => {
                    //console.log(res)
                    this.remarkHistoryList = res.data.list
                })
        },
        getUserDetailInfo(){
            request.saas
                .post('settlement/get_user_settlement_config', {
                    user_id: this.userId
                })
                .then(res => {
                    this.rate = res.data
                    this.settlementRateTemplate.id = res.data.settlement_rate_template.id
                    this.settlementRateTemplate.name = res.data.settlement_rate_template.name
                    this.settlementRateTemplate.default = res.data.settlement_rate_template.rates.default
                    this.settlementRateTemplate.iyunfu = res.data.settlement_rate_template.rates.iyunfu
                    this.settlementRateTemplate.qixin = res.data.settlement_rate_template.rates.qixin
                    this.settlementRateTemplate.niubao = res.data.settlement_rate_template.rates.niubao
                    this.settlementRateTemplate.fengqi = res.data.settlement_rate_template.rates.fengqi
                    this.settlementRateTemplate.create_time = res.data.settlement_rate_template.create_time
                    this.taxRateTemplate.id = res.data.tax_rate_template.id
                    this.taxRateTemplate.name = res.data.tax_rate_template.name
                    this.taxRateTemplate.rate = res.data.tax_rate_template.rate
                    this.taxRateTemplate.create_time = res.data.tax_rate_template.create_time
                    this.taxId = res.data.tax_rate_template.id
                    this.settlementId = res.data.settlement_rate_template.id
                })
            request.saas.post("uc/get_user_detail", {
                id: this.userId
            })
                .then(resp => {
                    this.detailItem = resp.data
                    this.detailItem.id = resp.data.id
                    this.detailItem.type = resp.data.user_info.type
                    this.detailItem.name = resp.data.user_info.name
                    this.detailItem.nickname = resp.data.user_info.nickname
                    this.detailItem.mobile = resp.data.user_info.mobile
                    this.detailItem.last_login = resp.data.user_info.last_login
                    this.detailItem.create_time = resp.data.user_info.create_time

                    this.detailItem.company_id = resp.data.user_certificate_info.company_id
                    //this.detailItem.company_license_url = resp.data.user_certificate_info.company_license_url
                    this.detailItem.company_name = resp.data.user_certificate_info.company_name
                    this.detailItem.extra = resp.data.user_certificate_info.extra
                    this.detailItem.id_card = resp.data.user_certificate_info.id_card

                    this.detailItem.last_apply_time = resp.data.user_certificate_info.last_apply_time
                    this.detailItem.last_audit_time = resp.data.user_certificate_info.last_audit_time
                    this.detailItem.uName = resp.data.user_certificate_info.name || '--'
                    this.detailItem.uStatus = resp.data.user_certificate_info.status
                    this.detailItem.uType = resp.data.user_certificate_info.type
                    this.detailItem.fatal_reason = resp.data.user_certificate_info.extra.fatal_reason
                    this.detailItem.company_platform_name = resp.data.user_certificate_info.extra.company_platform_name
                    this.detailItem.company_remark = resp.data.user_certificate_info.extra.company_remark
                    this.detailItem.person_certificate_id = resp.data.user_certificate_info.extra.person_certificate_id
                    this.detailItem.person_organization_name = resp.data.user_certificate_info.extra.person_organization_name

                    if(resp.data.user_certificate_info.company_license_url) {
                        //企业用户,个人用户没有营业执照
                        this.getIdentityPhoto(3,resp.data.user_certificate_info.company_license_url)
                    }
                    if(resp.data.user_certificate_info.id_card_front_url) {
                        this.getIdentityPhoto(1,resp.data.user_certificate_info.id_card_front_url)
                    }
                    if(resp.data.user_certificate_info.id_card_front_url) {
                        this.getIdentityPhoto(2,resp.data.user_certificate_info.id_card_back_url)
                    }

                })
        },
        getIdentityPhoto(type, filename){
            request.saas.post("common/get_private_object", {
                filename: filename
            }).then(res => {
                if(type === 1) {
                    this.front_url = res.data.content
                } else if(type === 2) {
                    this.back_url = res.data.content
                } else if(type === 3) {
                    this.company_license_url = res.data.content
                }
            })
        },
        handleEventShow(value) {
            this.showEventEdit = value
        },
        handleEventSave(form) {
            console.log('form', form)
            if (form.id) {
                request.saas
                    .post('uc/update_user_remark', {
                        id: form.id,
                        content: form.content,
                        type: form.type,
                        status: form.status,
                        todo_status: form.todo_status,
                        todo_remind_time: form.todo_remind_time
                    })
                    .then(() => {
                        this.showEventEdit = false
                        this.$message.success('保存成功')
                        this.getRemarkList()
                    })
            } else {
                request.saas
                    .post('uc/create_user_remark', {
                        user_id: this.userId,
                        content: form.content,
                        type: 2,
                        todo_status: form.todo_status ? form.todo_status : 1 ,
                        todo_remind_time: form.todo_remind_time
                    })
                    .then(() => {
                        this.showEventEdit = false
                        this.$message.success('保存成功')
                        this.getRemarkList()
                    })
            }
        },
        handleHistoryShow(value) {
            this.showHistoryEdit = value
        },
        handleHistorySave(form) {
            if (form.id) {
                request.saas
                    .post('uc/update_user_remark', {
                        id: form.id,
                        user_id: this.userId,
                        content: form.content,
                        type: form.type,
                        todo_status: form.todo_status,
                        todo_remind_time: form.date
                    })
                    .then(() => {
                        this.getRemarkList()
                        this.showHistoryEdit = false
                        this.$message.success('保存成功')
                    })
            }else {
                request.saas
                    .post('uc/create_user_remark', {
                        user_id: this.userId,
                        content: form.content,
                        type: form.type,
                        todo_status: 1,
                        todo_remind_time: form.date
                    })
                    .then(() => {
                        this.getRemarkList()
                        this.showHistoryEdit = false
                        this.$message.success('保存成功')
                    })
            }
            
        },
        goBack() {
            this.$router.push('/saas/saas_user')
        }
    }
}
</script>
<style scoped>
.body-container {
    margin: 20px 0;
}
.main-content .el-main{
    padding: 0 5px;
}
</style>
